export default __webpack_public_path__ + "static/media/Fireworks.706e726f.png";